/**
 * Whether the disease hit rate statistics is measured as
 * incidence or prevalence.
 *
 * @author jonmd
 */
class Measured {
  static INCIDENCE: Measured;
  static PREVALENCE: Measured;

  private static _values: Measured[] = [];
  private static _lookup: Map<string, Measured> = new Map();

  static fromTag(tag: string) {
    const state = Measured._lookup.get(tag);
    if (state === undefined) {
      throw new Error('Not a valid Measured.tag: ' + tag);
    }
    return state;
  }

  static values(): Measured[] {
    return [...Measured._values];
  }

  // ---

  readonly tag: string;
  readonly label: string;

  constructor(tag: string, label: string) {
    this.tag = tag;
    this.label = label;
    Measured._values.push(this);
    Measured._lookup.set(tag, this);
  }

  get labelLower(): string {
    return this.label.toLowerCase();
  }

  toString() {
    return '<Measured: tag=' + this.tag + ', label=' + this.label + '>';
  }
}

Measured.INCIDENCE = new Measured('i', 'Incidence');
Measured.PREVALENCE = new Measured('p', 'Prevalence');

export { Measured };
